import promotionsAPI from '@/module/promotions/api/promotions';

export default function promotions(instance) {
  return {
    promotions: promotionsAPI(instance),
  };
}
